updateTypePolicy